
import {Component, Mixins, Prop, Ref} from "vue-property-decorator";
import SimpleInputMixin from "@/mixins/SimpleInputMixin.vue";
import FormWrapper from "@/components/FormWrapper.vue";
import DeleteDialog from "@/components/dialogs/DeleteDialog.vue";
import FormDialog from "@/components/dialogs/FormDialog.vue";
import HacizForm from "@/components/forms/haciz/HacizForm.vue";
import {HacizTalebiEntity} from "@/entity/Haciz/HacizTalebiEntity";
import {HacizEntity} from "@/entity/Haciz/HacizEntity";
import {BorcluEntity} from "@/entity/BorcluEntity";
import SatisBilgiForm from "@/components/forms/satis/SatisBilgiForm.vue";
import {SatisBilgiEntity} from "@/entity/SatisBilgiEntity";
import {HacizTalepKodu} from "@/enum/haciz/HacizTalepKodu";
import {HacizTuru} from "@/enum/haciz/HacizTuru";

@Component({
  computed: {
    SatisBilgiEntity() {
      return SatisBilgiEntity
    }
  },
  components: {SatisBilgiForm, HacizForm, FormDialog, DeleteDialog, FormWrapper}
})
export default class HacizTalepForm extends Mixins(SimpleInputMixin) {
  @Prop() borclu!: BorcluEntity;
  @Ref('form') form!: FormWrapper;
  @Prop() uyapBilgileri!: any;
  tab = 0;
  error = false;
  localValue!: HacizTalebiEntity;
  HacizTalepKodu = HacizTalepKodu;
  hacizTuruList: Array<{ id: number; isim: string }> = [];

  headers = [
    {text: 'Haciz Türü', value: 'haciz_turu.isim'},
    {text: 'Açıklama', value: 'aciklama'},
    {text: 'Masraf', value: 'masraf'},
    {text: 'İşlemler', value: 'actions', align: 'center', width: 140}
  ];

  async mounted(){
    await this.loadHacizTuruList()
  }


  async loadHacizTuruList() {
    try {
      const response = await this.$helper.requestWithCache('/api/v1/haciz-turu');
      const raw = response.data?.data ?? response.data;
      this.hacizTuruList = Array.isArray(raw) ? raw : [];
    } catch (e: any) {
      this.$toast?.error('Haciz türleri yüklenemedi: ' + (e?.message || e));
    }
  }

  getHacizTuruIsim(item: any): string {
    const id = item.haciz_turu_id;
    if (id == null) return (item.haciz_turu || item.hacizTuru)?.isim ?? '';
    const found = this.hacizTuruList.find((t) => t.id === id);
    return found ? found.isim : (item.haciz_turu || item.hacizTuru)?.isim ?? '';
  }

  getAciklama(item: any): string {
    const ekstra = item.ekstra_data;
    if (item.haciz_turu_id === HacizTuru.gemiHaczi && ekstra) {
      const parts = [ekstra.gemi_adi, ekstra.gemi_cinsi, ekstra.gemi_sicil_no].filter(Boolean);
      return parts.length ? parts.join(' - ') : '';
    }
    return item.aciklama || (ekstra?.aciklama ?? '') || '';
  }

  get defaultHaciz() {
    let hacizObj = new HacizEntity();
    return hacizObj;
  }

  get toplamMasraf() {
    let tutar = 0;
    (this.localValue?.hacizler || []).forEach((haciz: HacizEntity | any) => {
      if (haciz.uyap_data) {
        if (haciz.uyap_data.talepKodu == 4)
          tutar += haciz.uyap_data.talepMasrafi * haciz.uyap_data.bankaList.length;
        else
          tutar += haciz.uyap_data?.talepMasrafi;
      }
    });
    if (this.localValue) this.localValue.talep_tutari = tutar;
    return tutar;
  }

  onAdd(v: any) {
    this.localValue.hacizler.push(v);
  }

  onUpdate(item: any, index: number) {
    let newArray = [...this.localValue.hacizler];
    newArray[index] = item;
    this.localValue.hacizler = newArray;
    this.input();
  }

  onDelete(index: number) {
    this.localValue.hacizler.splice(index, 1);
  }

  async onHacizEditClick(item: any, index: number) {
    if (!item.id || !this.localValue.id) return;
    try {
      const response = await this.$http.get('/api/v1/haciz-talep/' + this.localValue.id + '/hacizler/' + item.id);
      const data = response.data?.data !== undefined ? response.data.data : response.data;
      if (data && typeof data === 'object') {
        Object.assign(item, data);
      }
    } catch (e: any) {
      this.$toast?.error('Haciz verileri yüklenemedi: ' + (e?.message || e));
    }
  }

  load() {
    this.$emit('load');
  }

  async save() {
    this.form.onFly = true;
    // boş haciz talebi yollamamak için kontrol sağlanacak
    /*
        uyapa bağlıyken
        YENİ haciz
        Kaydet: Bilgileri direk dbye kaydet
        Kaydet ve Uyap'a Gönder: Bilgileri direk dbye kaydet, Uyap'a gönder, evrak idyi al ve dbdeki ilgili alanı güncelle, evrağı indir parse et ve ekstralara ekle
     */
    if (this.tab == 0) {
      if (!this.localValue || !this.localValue.hacizler || this.localValue.hacizler.length == 0) {
        this.error = true;
        this.form.onFly = false;
        return;
      }
      this.error = false;
      if (this.localValue.id) {
        await this.$http.put('/api/v1/haciz-talep/' + this.localValue.id, this.localValue).catch(() => { this.form.onFly = false; });
        this.form.onFly = false;
        this.$emit('onSuccess');
      } else {
        this.localValue.borclu_id = parseInt(this.$route.params.id);
        await this.$http.post('/api/v1/haciz-talep', this.localValue).catch(() => { this.form.onFly = false; });
        this.form.onFly = false;
        this.$emit('onSuccess');
      }
    } else {
      // MEVCUT haciz
      // Hacizi seçtir, evrakı parse et ve ekstralara ekle
      // uyaptan parse et aktar
    }
  }
}
